<template>
  <el-table-column
    :prop="celldata.prop"
    :label="celldata.label"
    :type="celldata.type"
    :width="celldata.width"
    :fixed="celldata.fixed"
    :sortable="celldata.sortable"
    :index="celldata.customIndex"
    :class-name="celldata.className"
    :align="celldata.align"
  >
    <span slot-scope="scope">
      <p
        v-for="(val, ind) in scope.row[celldata.prop]"
        :key="ind"
        class="multiLines"
      >
        <el-tooltip
          v-if="celldata.tooltip"
          class="item"
          effect="dark"
          :content="val"
          placement="top"
        >
          <span v-if="celldata.snshorten">{{ val.length>10 ? '...'+val.slice(-10) : (val||'-') }}</span>
          <span v-else>{{ val||'-' }}</span>
        </el-tooltip>
        <span v-else>{{ val||'-' }}</span>
        <br v-if="ind !== scope.row[celldata.prop].length - 1">
      </p>
    </span>
  </el-table-column>
</template>
<script>
export default {
  props: {
    celldata: Object
  }
}
</script>
<style lang="sass" scoped>
.multiLines
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
</style>
